import { OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../services/auth/auth.service';
import { ConfigService } from '../../services/config/config.service';
import { ReturnUrlService } from '../../services/return-url/return-url.service';
var NavbarComponent = /** @class */ (function () {
    function NavbarComponent(authService, returnUrlService, configService) {
        this.authService = authService;
        this.returnUrlService = returnUrlService;
        this.currentUser = null;
        this.destroy$ = new Subject();
        this.environment = configService.config.environment;
        this.productName = configService.config.productName;
    }
    NavbarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authService.userInfoSubject
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (user) {
            _this.currentUser = user;
        });
    };
    NavbarComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    Object.defineProperty(NavbarComponent.prototype, "isLoginInProgress", {
        get: function () {
            return this.authService.isLoginInProgress;
        },
        enumerable: true,
        configurable: true
    });
    NavbarComponent.prototype.isLoggedIn = function () {
        return !!this.currentUser;
    };
    NavbarComponent.prototype.login = function () {
        this.returnUrlService.clear();
        this.authService.login();
    };
    NavbarComponent.prototype.logout = function () {
        this.authService.logout();
    };
    NavbarComponent.prototype.councilName = function () {
        return this.currentUser ? this.currentUser.councilName : '';
    };
    NavbarComponent.prototype.userName = function () {
        return this.currentUser ? this.currentUser.username : '';
    };
    return NavbarComponent;
}());
export { NavbarComponent };
